<template>
  <div
    class="fixed account-settings-container top-0 column-flex sidebar-width sidebar-border left-0 vh-100 pt3 pl4 bg-white silver z-99 dn db-xl cera-round-pro"
  >
  <div>
    <router-link  to="/">
      <div class="white dib mt3">
        <img alt="" class="h2"
             :src="logoSrc"
             style="padding-top:.2rem; padding-bottom:0; margin-bottom: -0.2rem;"/>
      </div>
    </router-link>
    <div class="mt4">
      <router-link :class="dashboardRoute ? 'color-theme bold' : 'font-menu'" class="no-underline flex items-end" to="/">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 6.34674L8.33755 2.19531L13.6751 6.34674V12.8704C13.6751 13.185 13.5501 13.4867 13.3277 13.7091C13.1052 13.9316 12.8035 14.0565 12.489 14.0565H4.18612C3.87154 14.0565 3.56985 13.9316 3.34741 13.7091C3.12497 13.4867 3 13.185 3 12.8704V6.34674Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.55859 14.0556V8.125H10.117V14.0556" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="ml2">{{ $t('menu.home', {home: 'Home'}) }}</span>
      </router-link>
    </div>
    <div class="mt3">
      <router-link :class="devicesRoute ? 'color-theme bold' : 'font-menu'" class="no-underline flex items-end" to="/devices">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_3064_3126" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <rect width="16" height="16" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_3064_3126)">
          <path d="M7.9 14.4453C7.9 14.4453 12.8 11.9953 12.8 8.32032V4.03281L7.9 2.19531L3 4.03281V8.32032C3 11.9953 7.9 14.4453 7.9 14.4453Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
        <span class="ml2 v-top">{{ $t('menu.items', {items: 'Items'}) }}</span>
      </router-link>
    </div>
    <div class="mt3">
      <router-link :class="claimsRoute ? 'color-theme bold' : 'font-menu'" class="no-underline flex items-end" :to="featureFlagRedirectClaimV2 ? '/claims-v2' : '/claims'">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_3064_3130" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <rect width="16" height="16" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_3064_3130)">
          <path d="M11.8443 14.1952H4.15194C3.71351 14.1933 3.29372 14.0249 2.9842 13.7268C2.67468 13.4286 2.5006 13.025 2.5 12.604V3.78654C2.50061 3.36551 2.67468 2.96188 2.9842 2.66372C3.29372 2.36565 3.71351 2.19722 4.15194 2.19531H10.0799C10.4463 2.19473 10.7982 2.33268 11.0596 2.57936L13.0801 4.4994L13.0802 4.49932C13.3481 4.75261 13.4992 5.09831 13.5 5.45934V12.6041C13.4994 13.0257 13.3248 13.4299 13.0144 13.7281C12.7041 14.0264 12.2833 14.1944 11.8443 14.1953L11.8443 14.1952ZM4.15194 3.15519C3.97805 3.15519 3.81138 3.22182 3.68892 3.34034C3.56646 3.45887 3.49829 3.61941 3.4996 3.7864V12.6038C3.49829 12.7708 3.56646 12.9314 3.68892 13.0499C3.81139 13.1684 3.97805 13.2351 4.15194 13.2351H11.8443C12.0182 13.2351 12.1849 13.1684 12.3073 13.0499C12.4298 12.9314 12.498 12.7708 12.4967 12.6038V5.45655C12.4945 5.35376 12.4494 5.25607 12.3717 5.18535L10.3523 3.2653V3.26538C10.2798 3.19608 10.1822 3.15648 10.0799 3.15498L4.15194 3.15519Z" fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
          </g>
        </svg>
        <span
          class="ml2 v-top">{{ $t('menu.claims', {claims: 'Claims'}) }}</span>
      </router-link>
    </div>


    <div class="mt3">
      <router-link :class="accountRouteNew ? 'color-theme bold' : 'font-menu'" class="no-underline flex items-end" to="/account">
        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_3064_3135" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <rect width="16" height="16" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_3064_3135)">
          <path d="M7.99952 2C9.71268 2 11.1084 3.45372 11.1084 5.24107C11.1084 7.02707 9.71397 8.48214 7.99952 8.48214C6.28635 8.48214 4.89062 7.02841 4.89062 5.24107C4.89062 3.45238 6.28249 2 7.99952 2ZM7.99952 2.89367C6.75673 2.89367 5.74785 3.94545 5.74785 5.24107C5.74785 6.53937 6.75416 7.58847 7.99952 7.58847C9.24487 7.58847 10.2512 6.53937 10.2512 5.24107C10.2512 3.94277 9.24487 2.89367 7.99952 2.89367Z" fill="currentColor" stroke="currentColor" stroke-width="0.6"/>
          <path d="M3.35594 13.7609C3.35594 14.0074 3.16316 14.207 2.92797 14.207C2.69149 14.207 2.5 14.0061 2.5 13.7609C2.5 12.074 3.82247 10.6953 5.44053 10.6953H10.5595C12.1762 10.6953 13.5 12.0753 13.5 13.7609C13.5 14.0074 13.3072 14.207 13.072 14.207C12.8356 14.207 12.6441 14.0061 12.6441 13.7609C12.6441 12.5671 11.7059 11.589 10.5608 11.589H5.44182C4.29413 11.589 3.35851 12.5657 3.35851 13.7609H3.35594Z" fill="currentColor" stroke="currentColor" stroke-width="0.6"/>
          </g>
        </svg>
        <span class="ml2 v-top">{{ $t('menu.account', {account: 'Account'}) }}</span>
      </router-link>
    </div>

    <div v-if="uiSettings[showReferrals] !== false">
      <div class="mt4 fw5">{{ $t('menu.storage', {storage: 'STORAGE'}) }}</div>
      <div class="mt3">
        <router-link :class="storageRoute ? 'color-theme bold' : 'font-menu'" class="no-underline" to="/storage">
          <svg fill="none" height="19" viewBox="0 0 15 14" width="19" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.64283 13.1952H9.37966C11.9389 13.1952 14.0225 11.1116 14.0225 8.55241L14.0227 4.83814C14.0227 2.27888 11.939 0.195312 9.37982 0.195312L5.64283 0.19547C3.08357 0.19547 1 2.27908 1 4.8383V8.57513C1.00016 11.1117 3.08373 13.1953 5.64283 13.1953L5.64283 13.1952ZM2.13252 4.83814C2.13252 2.91299 3.71784 1.32767 5.643 1.32767H9.37983C11.305 1.32767 12.8903 2.91299 12.8903 4.83814V8.57497C12.8903 10.5001 11.305 12.0854 9.37983 12.0854H8.08881V6.67259L9.90069 8.48446C10.1272 8.71101 10.4895 8.71101 10.6934 8.48446C10.92 8.25792 10.92 7.89566 10.6934 7.6917L7.90763 4.90605C7.79436 4.79277 7.65849 4.74743 7.50005 4.74743C7.34143 4.74743 7.20557 4.79277 7.09246 4.90605L4.32941 7.6917C4.10287 7.91825 4.10287 8.28051 4.32941 8.48446C4.55596 8.71101 4.91822 8.71101 5.12217 8.48446L6.93405 6.67259V12.0628H5.64304C3.71788 12.0628 2.13256 10.4775 2.13256 8.55233L2.13252 4.83814Z"
              fill="currentColor" stroke="currentColor" stroke-width="0.15"/>
          </svg>
          <span
            class="ml1 v-top">{{ $t('menu.upload', {upload: 'Upload'}) }}</span>
        </router-link>
      </div>
    </div>
    
    <div class="mt4 fw5 pr6">{{ $t('menu.support', {support: 'SUPPORT'}) }}</div>
    <div class="mt3">
      <router-link :class="contactRoute ? 'color-theme bold' : 'font-menu'" class="no-underline" to="/contact">
        <svg fill="none" height="19" viewBox="0 0 14 14" width="19" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.54696 13.1978C8.5505 13.1874 7.56792 12.9623 6.66637 12.5376C4.3484 11.5166 2.51695 9.63645 1.55697 7.29254C1.15142 6.35703 0.963041 5.3418 1.00599 4.32322C1.06242 3.16258 1.45608 2.19274 2.1751 1.43534C2.22952 1.3826 2.28996 1.33622 2.3551 1.29737L2.39353 1.271L2.49793 1.19531H2.89519L2.96116 1.22051C3.56128 1.44254 3.99455 1.84466 4.41584 2.2323H4.41592C4.75165 2.53737 5.06905 2.86206 5.36651 3.20447C5.71071 3.6009 5.89655 4.11027 5.8886 4.63521C5.88525 4.82024 5.85494 5.00383 5.7986 5.18016C5.72936 5.41843 5.59256 5.63158 5.4046 5.79368C5.21672 5.95577 4.9859 6.05992 4.74 6.09349C4.758 6.87244 5.14933 7.70539 5.82623 8.37995C6.50321 9.05451 7.32771 9.43855 8.0994 9.45419V9.44582C8.21946 8.67046 9.02595 8.18554 9.6789 8.22875C9.98608 8.24859 10.2834 8.34563 10.5431 8.51081C10.7762 8.65272 10.9959 8.81539 11.1996 8.99691C11.6942 9.44726 12.1444 9.94399 12.5439 10.4804C12.6545 10.639 12.7532 10.8054 12.8392 10.9785C12.874 11.0445 12.9087 11.1117 12.946 11.1765L13 11.2665V11.6723L12.9484 11.7575C12.8041 11.9881 12.6107 12.184 12.3819 12.3312L12.3483 12.3552C11.7674 12.7787 11.0884 13.0475 10.3751 13.1366C10.1007 13.1758 9.82399 13.1962 9.54686 13.1978L9.54696 13.1978ZM2.74886 1.98619C2.16071 2.6019 1.84985 3.37968 1.80186 4.35796C1.76452 5.2578 1.93155 6.15447 2.29038 6.9805C3.17207 9.14029 4.85676 10.8742 6.99063 11.8175C8.11283 12.3288 9.18472 12.5053 10.2686 12.3576H10.2685C10.8504 12.2861 11.4046 12.0681 11.8792 11.7238L11.9128 11.6986H11.9129C12.0167 11.629 12.1129 11.5486 12.1997 11.4586L12.1409 11.3481H12.1409C12.0705 11.209 11.9903 11.075 11.9008 10.9473C11.5324 10.4514 11.1172 9.99202 10.661 9.5754C10.4929 9.42696 10.3117 9.29392 10.1197 9.17814C9.97086 9.08421 9.80081 9.02928 9.62517 9.01848C9.36227 9.00048 8.93739 9.20812 8.88464 9.56344C8.87711 9.62313 8.87317 9.68324 8.87258 9.74344V9.85504L8.85341 10.1851L8.52572 10.2247C7.4287 10.3579 6.21397 9.8778 5.27435 8.94163C4.33473 8.00546 3.84361 6.78119 3.97564 5.6686L4.01767 5.31931H4.52419C4.64207 5.32559 4.75854 5.29135 4.85439 5.22236C4.95017 5.15346 5.01957 5.05383 5.05114 4.94005C5.08362 4.83832 5.10103 4.73241 5.10271 4.62558C5.10857 4.29078 4.98809 3.96594 4.76548 3.71586C4.48778 3.39822 4.19157 3.09724 3.87844 2.81441C3.51843 2.47834 3.17149 2.15552 2.74903 1.98622L2.74886 1.98619Z"
            fill="currentColor" stroke="currentColor" stroke-width="0.5"/>
        </svg>
        <span
          class="ml1 v-top">{{ $t('menu.contactus', {contactus: 'Contact Us'}) }}</span>
      </router-link>
    </div>
    <div class="mt3">
      <a :href="faqUrl" target="_blank" :class="faqRoute ? 'color-theme bold' : 'font-menu'" class="color-theme no-underline">
        <svg class="mr1" fill="none" height="19" viewBox="0 0 15 14" width="19" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.5 1.10531C8.6056 1.10531 9.68637 1.43316 10.6056 2.0474C11.5249 2.66163 12.2414 3.53467 12.6645 4.55611C13.0876 5.57755 13.1983 6.70151 12.9826 7.78587C12.7669 8.87022 12.2345 9.86627 11.4527 10.648C10.671 11.4298 9.67491 11.9622 8.59056 12.1779C7.50621 12.3936 6.38224 12.2829 5.3608 11.8598C4.33936 11.4367 3.46633 10.7202 2.85209 9.80095C2.23785 8.88168 1.91 7.80091 1.91 6.69531C1.91 5.21275 2.49895 3.79091 3.54728 2.74259C4.5956 1.69426 6.01744 1.10531 7.5 1.10531ZM7.5 0.195313C6.21442 0.195313 4.95772 0.576531 3.8888 1.29076C2.81988 2.00499 1.98676 3.02015 1.49479 4.20787C1.00282 5.39559 0.874095 6.70252 1.1249 7.9634C1.3757 9.22428 1.99477 10.3825 2.90381 11.2915C3.81285 12.2005 4.97104 12.8196 6.23192 13.0704C7.49279 13.3212 8.79973 13.1925 9.98745 12.7005C11.1752 12.2086 12.1903 11.3754 12.9046 10.3065C13.6188 9.2376 14 7.98089 14 6.69531C14 4.97141 13.3152 3.3181 12.0962 2.09912C10.8772 0.880132 9.22391 0.195313 7.5 0.195312V0.195313Z"
            fill="currentColor" stroke="currentColor" stroke-width="0.3"/>
          <path
            d="M7.60254 3.44531C7.8338 3.46947 8.06343 3.50723 8.29024 3.55841C8.98314 3.75471 9.39524 4.30851 9.44724 5.04431C9.47232 5.28008 9.43495 5.5183 9.33889 5.73506C9.24283 5.95183 9.09145 6.13952 8.89994 6.27931C8.71534 6.42231 8.52164 6.55231 8.33574 6.69271C8.20104 6.78096 8.09194 6.9031 8.01937 7.04685C7.94681 7.19061 7.91335 7.35093 7.92234 7.51171C7.92696 7.62775 7.89261 7.74199 7.82475 7.83623C7.7569 7.93047 7.65945 7.99929 7.54794 8.03171C7.42923 8.0774 7.29871 8.08241 7.17684 8.04594C7.05497 8.00947 6.94865 7.9336 6.87454 7.83021C6.82598 7.74872 6.79954 7.65596 6.79784 7.56111C6.7886 7.26722 6.85128 6.97551 6.98042 6.71134C7.10955 6.44718 7.30125 6.21854 7.53884 6.04531C7.74751 5.8865 7.94433 5.71271 8.12774 5.52531C8.21518 5.42231 8.26834 5.29463 8.27984 5.16001C8.30974 4.79211 8.07314 4.55551 7.69224 4.53081C7.23204 4.50091 6.84464 4.62051 6.57424 5.02741C6.51783 5.12332 6.43339 5.19965 6.33229 5.24614C6.23119 5.29262 6.11828 5.30702 6.00874 5.28741C5.61874 5.22241 5.45104 4.90521 5.61094 4.53991C5.77833 4.18389 6.06609 3.89844 6.42344 3.73391C6.79089 3.55333 7.19323 3.45485 7.60254 3.44531Z"
            fill="currentColor" stroke="currentColor" stroke-width="0.1"/>
          <path
            d="M7.99169 9.28055C7.99429 9.69785 7.76029 9.94615 7.35079 9.94615C6.94129 9.94615 6.66829 9.70695 6.66699 9.35725C6.66699 8.87235 6.88409 8.63055 7.31699 8.61755C7.66929 8.60715 8.03589 8.82295 7.99169 9.28055Z"
            fill="currentColor" stroke="currentColor" stroke-width="0.1"/>
        </svg>
        <span class="ml1 v-top">{{ $t('menu.faq', {faq: 'FAQ'}) }}</span>
    </a>
    </div>

  </div>
    <div class="flex flex-column">
      <router-link
        class="referral nowrap mt4 pv2 no-underline f6 v-top inter"
        v-if="uiSettings[showReferrals] !== false"
        to="/account/referrals">
        Get $20 for Referrals
      </router-link>
  
      <div class="mt4 pb4">
        <div class="font-menu logout" @click="logOut">
          <img alt="" class="mr1" height="19" src="../../static/menu-icons/logout.svg" width="19"/><span
          class="ml1 v-top">{{ $t('menu.logout', {logout: 'Logout'}) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { AKKO_ACCOUNT, AKKO_CLAIMS, AKKO_CLOUD_STORAGE, AKKO_CONTACT, AKKO_DASHBOARD, AKKO_DEVICES, AKKO_FAQ, AKKO_MENTOR, DASHBOARD } from '../constants/sidebar/sidebar'
import { USER_WEB_SHOW_REFERRALS, USER_WEB_STORAGE_VIEW_TAB, CUSTOM_FAQ_URL } from '@/constants/ui-settings/uiSettings'
import { GET_FEATURE_FLAG } from '@/store/index'
import { REDIRECT_CLAIM_V2 } from '@/constants/feature_flag'
import { GET_PARTNER } from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'ak-app-sidebar',
  data () {
    return {
      showReferrals: USER_WEB_SHOW_REFERRALS,
      viewStorageTab: USER_WEB_STORAGE_VIEW_TAB,
      customFaqUrl: CUSTOM_FAQ_URL
    }
  },
  computed: {
    ...mapGetters({
      partner: GET_PARTNER
    }),
    devicesRoute () {
      return this.$route.name === AKKO_DEVICES
    },
    accountRoute () {
      return this.$route.name === AKKO_ACCOUNT
    },
    accountRouteNew () {
      return this.$route.name === DASHBOARD || this.$route.path.includes('account/')
    },
    claimsRoute () {
      return this.$route.name === AKKO_CLAIMS
    },
    dashboardRoute () {
      return this.$route.name === AKKO_DASHBOARD
    },
    storageRoute () {
      return this.$route.name === AKKO_CLOUD_STORAGE
    },
    faqRoute () {
      return this.$route.name === AKKO_FAQ
    },
    contactRoute () {
      return this.$route.name === AKKO_CONTACT
    },
    mentorRoute () {
      return this.$route.name === AKKO_MENTOR
    },
    keyboardOpen () {
      return this.$store.state.keyboardOpen
    },
    featureFlagRedirectClaimV2 () {
      const feature = this.$store.getters[GET_FEATURE_FLAG](REDIRECT_CLAIM_V2)
      return feature ? feature.state : false
    },
    logoSrc () {
      const logoSrc = process.env.VUE_APP_WHITE_LABEL_BRAND_IMAGE_URL
      return logoSrc || '/static/menu-icons/logo.svg'
    },
    uiSettings () {
      const uiSettings = this.partner && this.partner.settings && this.partner.settings.ui_settings
      return uiSettings || {}
    },
    faqUrl () {
      const customFaqUrl = this.uiSettings[this.customFaqUrl]
      return customFaqUrl || 'https://help.getakko.com/en'
    }
  },
  methods: {
    logOut () {
      this.$store.commit('SET_TOKEN', {access_token: '', id: 0})
      this.$store.commit('CLEAR_USER')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 80em) {
  .db-xl {
    display: block;
  }

  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }

  .font-menu {
    color: #060920;
    font-weight: 400;
  }

  .sidebar-shadow {
    box-shadow: rgb(0, 0, 0, 0.15) 2px 2px 2px;
  }

  .logout {
    cursor: pointer;
  }

  .last-section {
    width: 221px;
  }

  .referral {
    background-color: #E8E8E8;
    width: 221px;
    color: #060920;
    margin-left: -1.9rem;
    padding-left: 1.9rem;
    font-size: 0.9rem;
  }

  .referral:hover {
    background-color: #F5F5F5;
    color: #575757;
  }

  .sidebar-border {
    border-right: 1px solid #E8E8E8;
  }

  .sidebar-width {
    width: 221px;
  }

  .account-settings-container {
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// AppSidebar.vue?13f41d3c